import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from 'app/services/users/user.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {
  @Input() title: string;

  @Input() menuItems: any[];

  constructor(private router: Router, private userService: UserService) {}

  ngOnInit() {
  }

  menuClick() {
   document.getElementById('main-panel').style.marginRight = '260px';
  }

  toEditProfile(){
    this.router.navigate(['/dashboard/profile']);
  }

  async logout(){
    await this.userService.logout();
    this.router.navigate(['']);
  }
}
